var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntrusion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83203 16.5L7.16536 13.1667L4.66536 10.6667V5.66667M4.66536 5.66667L1.33203 8.16667L2.16536 10.6667M4.66536 5.66667L7.9987 8.16667L10.4987 8.58333M3.83203 13.1667L2.16536 16.5M12.5448 6.59746L15.4987 5.25M12.9987 9L15.1795 9.45391M11.7487 11.0833L14.2487 13.1667M4.66536 2.33333C4.66536 2.55435 4.75316 2.76631 4.90944 2.92259C5.06572 3.07887 5.27768 3.16667 5.4987 3.16667C5.71971 3.16667 5.93167 3.07887 6.08795 2.92259C6.24423 2.76631 6.33203 2.55435 6.33203 2.33333C6.33203 2.11232 6.24423 1.90036 6.08795 1.74408C5.93167 1.5878 5.71971 1.5 5.4987 1.5C5.27768 1.5 5.06572 1.5878 4.90944 1.74408C4.75316 1.90036 4.66536 2.11232 4.66536 2.33333Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntrusion);
export default __webpack_public_path__ + "static/media/Intrusion.d835c67396f27f48d9c25e0d6aeede40.svg";
export { ForwardRef as ReactComponent };